import type { Currency } from "@common/client"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@common/components/ui/select"
import { CURRENCIES } from "@common/lib/currency"

export const CURRENCY_SYMBOL: Record<Currency, string> = {
  usd: "$",
  cad: "C$",
  eur: "€",
  gbp: "£",
  aud: "A$",
}

const TRIGGER =
  "h-full w-auto gap-0.5 rounded-none border-0 border-r border-input bg-greyscale-off-white py-0 pl-3 pr-2 text-body-medium leading-none shadow-none focus:ring-0 focus:ring-offset-0 [&>svg]:h-3 [&>svg]:w-3 [&>svg]:opacity-100"

export function CurrencySelect({
  value,
  disabled,
  onChange,
}: {
  value: Currency
  disabled?: boolean
  onChange: (next: Currency) => void
}): React.ReactElement {
  return (
    <Select
      value={value}
      disabled={disabled}
      onValueChange={(next) => onChange(next as Currency)}
    >
      <SelectTrigger aria-label="Currency" className={TRIGGER}>
        <SelectValue>{CURRENCY_SYMBOL[value]}</SelectValue>
      </SelectTrigger>
      <SelectContent align="start">
        {CURRENCIES.map((currency) => (
          <SelectItem key={currency} value={currency}>
            {CURRENCY_SYMBOL[currency]} {currency.toUpperCase()}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
